
import { IconButton, Stack } from '@mui/material';
import { Cancel, CheckCircle } from '@mui/icons-material';
import { useMemo } from 'react';
import Model from '../models/model';

const StsResultButton = ({ inputProps }) => {
	const { formik, activeRecord } = inputProps;
	const stsResult = useMemo(() => {
		return parseInt(formik.values.STSResult);
	},[formik.values.STSResult]);

	return (
		<Stack direction="row" spacing={2} sx={{
			'& .MuiIconButton-root': {
				'&.IsSelected': {
					backgroundColor: (theme) => theme.palette.divider,
				}
			}
		}}>
			<IconButton color="success" className={stsResult === 1 ? 'IsSelected' : ''} onClick={() => {
				formik.setFieldValue('STSResult', 1);
				activeRecord.record.STSResult = 1;
			}}>
				<CheckCircle fontSize='inherit' />
			</IconButton>
			<IconButton color="error" className={stsResult === 2 ? 'IsSelected' : ''} onClick={() => {
				formik.setFieldValue('STSResult', 2);
				activeRecord.record.STSResult = 2;
			}}>
				<Cancel fontSize='inherit' />
			</IconButton>
		</Stack>
	)
}
const model = new Model({
	name: 'EndoSystemCycle',
	onFormLoad: ({ formik, activeRecord }) => {
		const  { values } = formik;
		const { record } = activeRecord;
		if (values.STSResult === 0) {
			formik.setFieldValue('STSResult', null);
		}
		if(values.STSLotNumber === '') {
			formik.setFieldValue('STSLotNumber', record.STSLotNumber);
		}
	},
	customizeSaveData: (toSave, { activeRecord }) => {
		const { record } = activeRecord;
		toSave.CycleId = record.CycleId;
		toSave.STSResult = record.STSResult || null;
		activeRecord.id = record.EndoSystemCycleId;
		return toSave;
	},
	columns: [
		{ header: 'STSLotNumber', field: 'STSLotNumber' },
		{ header: 'STSResult', field: 'STSResult', customizeInput: StsResultButton, required: true, type: 'number' }
	]
});
export const StsResultModel = model;
export default model.createFormBase();
